<template>
  <a-modal
    v-model="seeVisible"
    :width="780"
    :title="`${from.userId ? $t('childAct_编辑子账号') : $t('childAct_新增子账号')}`"
    cancelText="false"
    @ok="seeVisible = false"
  >
    <!-- <a-config-provider :auto-insert-space-in-button="false">
      <a-button class="login-btn" @click="isTips= false" type="primary">
          返回
      </a-button>
    </a-config-provider></div> -->
    <div class="child-act__box">
      <div class="child-act_input">
        <span :class="currentLang === 'zh_CN' ? 'known':'known-13'"><i>*</i>{{$t('authority_account_phone')}}：</span>
        <div v-if="!from.userId">
          <a-input
            :placeholder="$t('authority_account_number')"
            @keyup="from.phone = from.phone.replace(/[^\d]/g, '')"
            :maxLength="Number(num)"
            class="login-input"
            v-model="from.phone"
          >
            <a-select
              slot="addonBefore"
              :disabled="!!from.userId"
              :value="countryCode | disCountryCode"
              style="width: 80px;font-size:14px;"
              :dropdownMatchSelectWidth="false"
              :dropdownStyle="{width:'270px'}"
              @select="changeInternational"
            >
              <a-select-option
                v-for="(item, index) in countryCodeList"
                :value="item.id"
                :key="item.phonecode+index"
              >
                <div slot="div" style="display:flex;justify-content:space-between;">
                  <span slot="span">{{item.name_zh}}</span>
                  <span slot="span">+ {{item.phonecode}}</span>
                </div>
              </a-select-option>
            </a-select>
          </a-input>
        </div>
        <div v-else>{{countryCode | disCountryCode}} - {{from.phone}}</div>
      </div>
      <div class="child-act_input">
        <span :class="currentLang === 'zh_CN' ? 'known':'known-13'">{{$t('common_form_email')}}：</span>
        <!-- <div v-if="!from.userId">
          <a-input :placeholder="$t('childAct_请输入邮箱号')" class="login-input" v-model="from.email" />
        </div>
        <div v-else>{{from.email}}</div> -->
        <a-input :placeholder="$t('childAct_请输入邮箱号')" class="login-input" v-model="from.email" :disabled="from.userId ? true : false"/>
      </div>
      <div class="child-act_input">
        <span :class="currentLang === 'zh_CN' ? 'known':'known-13'"><i>*</i>{{$t('common_form_real_name')}}：</span>
        <a-input :placeholder="$t('childAct_输入姓名')" autocomplete="off" class="login-input" v-model="from.realName" />
      </div>
      <div class="child-act_input" v-show="!from.userId">
        <span :class="currentLang === 'zh_CN' ? 'known':'known-13'"><i>*</i>{{$t('authority_account_password')}}：</span>
        <a-input type="password" autocomplete="new-password" :placeholder="$t('common_home_enter_email_address_format_numbers')" class="login-input" v-model="from.pwd" />
      </div>
      <div class="child-act_input" v-show="!from.userId">
        <span :class="currentLang === 'zh_CN' ? 'known':'known-13'"><i>*</i>{{$t('common_home_enter_conf_pws')}}：</span>
        <a-input type="password" autocomplete="new-password" :placeholder="$t('common_home_enter_email_address_format_again')" class="login-input" v-model="from.morepwNum" />
      </div>
      <div class="power">
        <span :class="currentLang === 'zh_CN' ? 'known':'known-13'"><i>*</i>{{$t('childAct_权限分配')}}：</span>
        <div class="child-act_loading">
          <a-spin :spinning="loadingFis"></a-spin>
        </div>
        <div v-show="!loadingFis">
          <a-checkbox v-model="checked" v-if="treeOriginalList && treeOriginalList.length" class="child-act_checkbox" @change="allOnChange">
            {{$t('common_form_select_All')}}
          </a-checkbox>
          <a-tree
            checkable
            v-model="checkedKeys"
            :tree-data="treeData"
            :replace-fields="replaceFields"
            @select="onSelect"
            @check="onCheck"
            v-if="!loadingFis"
          />
        </div>
      </div>
    </div>
    <template slot="footer">
      <a-config-provider :auto-insert-space-in-button="false">
        <a-button class="login-editbtn" @click="saveBtn" :loading="isLoading" type="primary">
          {{$t('common_btn_submit')}}
        </a-button>
      </a-config-provider>
    </template>
  </a-modal>
</template>

<script>
import { AddSysSubAccount, PhoneCodeInterface, SsoGetUserEditRoleMenuBySys } from '@/api/login'
import { encrypt, openNotificationWithIcon } from '@/utils/util'
import { mapState } from 'vuex'

export default {
  name: 'edit',
  data () {
    return {
      num: 11,
      checkedKeys: [],
      treeData: [],
      treeOriginalList: [],
      isLoading: false,
      seeVisible: false,
      replaceFields: {
        children: 'child',
        title: 'name'
      },
      from: {},
      loadingFis: false,
      checked: false,
      countryCode: ' 86',
      countryCodeList: [
        { name_zh: '中国大陆', numcode: '156', iso: 'CN', name: 'CHINA', nicename: 'China', phonecode: '86', id: '44', sort: '9999', iso3: 'CHN' },
        { name_zh: '中国香港', numcode: '344', iso: 'HK', name: 'HONG KONG', nicename: 'Hong Kong', phonecode: '852', id: '96', sort: '9998', iso3: 'HKG' },
        { name_zh: '中国澳门', numcode: '446', iso: 'MO', name: 'MACAO', nicename: 'Macao', phonecode: '853', id: '125', sort: '9997', iso3: 'MAC' },
        { name_zh: '中国台湾', numcode: '158', iso: 'TW', name: 'TAIWAN, PROVINCE OF CHINA', nicename: 'Taiwan, Province of China', phonecode: '886', id: '208', sort: '9996', iso3: 'TWN' },
        { name_zh: '美国', numcode: '840', iso: 'US', name: 'UNITED STATES', nicename: 'United States', phonecode: '1', id: '226', sort: '9995', iso3: 'USA' },
        { name_zh: '澳大利亚', numcode: '36', iso: 'AU', name: 'AUSTRALIA', nicename: 'Australia', phonecode: '61', id: '13', sort: '9993', iso3: 'AUS' },
        { name_zh: '英国', numcode: '826', iso: 'GB', name: 'UNITED KINGDOM', nicename: 'United Kingdom', phonecode: '44', id: '225', sort: ' 9993', iso3: 'GBR' }
      ]
    }
  },
  filters: {
    disCountryCode (val) {
      return `+ ${val}`
    }
  },
  computed: {
    ...mapState({
      'subjectId': state => state.isLogin.subjectId,
      currentLang: state => state.isLogin.lang
    })
  },
  mounted () {
    this.$store.dispatch('_SsoGetUserInfo')
  },
  methods: {
    show (from = {}) {
      this.from = from
      this.seeVisible = true
      this.checkedKeys = []
      this.treeOriginalList = []
      this.editBtn()
      if (this.from.phoneCode) {
        this.countryCode = this.from.phoneCode
      } else {
        this._PhoneCodeInterface()
      }
    },
    editBtn () {
      this.isTips = true
      this.loadingFis = true
      let data = {
        optSubjectId: '',
        optUserId: '',
        userId: this.from.userId,
        roleId: '',
        systemCode: 'OPEN_API_PORTAL'
      }
      SsoGetUserEditRoleMenuBySys(data).then((res) => {
        this.treeData = []
        this.checkedKeys = []
        let allLength = []
        if (res.code === '200') {
          res.data && (this.treeOriginalList = res.data.filter(item => item.menuStatus === 1))
          res.data && res.data.filter(item => item.menuStatus === 1).map((item) => {
            if (item.childMenus) {
              let childArray = []
              item.childMenus.map((items) => {
                childArray.push({ name: items.menuName, key: item.menuId + '-' + items.menuId })
                allLength.push(item.menuId + '-' + items.menuId)
                if (items.isShow === 1) {
                  this.checkedKeys.push(item.menuId + '-' + items.menuId)
                }
              })
              this.treeData.push({ name: item.menuName, key: String(item.menuId), child: childArray })
            } else {
              this.treeData.push({ name: item.menuName, key: String(item.menuId), child: [] })
            }
          })
          this.checked = this.checkedKeys.length === allLength.length
          // console.log(this.treeData)
          console.log(this.checkedKeys)
        } else {
          openNotificationWithIcon(res.message)
        }
      })
        .finally(() => {
          this.loadingFis = false
        })
    },
    onSelect (selectedKeys, info) {
      console.log('selected', selectedKeys, info)
    },
    allOnChange (e) {
      if (e.target.checked) {
        this.deepChange(this.treeOriginalList)
      } else {
        this.checkedKeys = []
      }
    },
    deepChange (data, flag) {
      console.log('data', data)
      for (let i of data) {
        i.menuId && i.parentId && this.checkedKeys.push(i.parentId + '-' + i.menuId)
        i.childMenus && i.childMenus.length && this.deepChange(i.childMenus, flag)
      }
      console.log('checkedKeys', this.checkedKeys)
    },
    onCheck (checkedKeys, info) {
      console.log('onCheck', checkedKeys, info)
    },
    saveBtn () {
      let menuFuncList = []
      let roleMenuList = []
      let menuList = []
      console.log('this.checkedKeys', this.checkedKeys)
      this.checkedKeys.forEach(item => {
        let itemAry = item.split('-')
        console.log('itemAry', itemAry)
        itemAry.forEach((it, index) => {
          if (index > 0) {
            const menuObj = {
              menuId: itemAry[0],
              functionId: itemAry[1]
            }
            menuFuncList.push(menuObj)
          } else {
            if (!menuList.includes(it)) {
              menuList.push(it)
            }
          }
        })
      })
      menuFuncList.map(it => {
        if (!roleMenuList.find(item => item.menuId === it.menuId)) {
          roleMenuList.push({ menuId: it.menuId })
        }
        roleMenuList.push({ menuId: it.functionId })
      })
      console.log('menuFuncList', menuFuncList)
      console.log('roleMenuList', roleMenuList)
      const { userId, phone, email, realName, morepwNum, pwd, userName } = this.from
      // console.log(menuFuncList)
      // console.log(roleMenuList)
      const regEmail = /^.+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!this.from.userId && !phone) return openNotificationWithIcon(this.$t('common_home_enter_mobile'))
      // if (phone.length !== 11) return openNotificationWithIcon('请输入完整手机号')
      // if (!this.from.userId && !email) return openNotificationWithIcon(this.$t('childAct_请输入邮箱'))
      if (email && !regEmail.test(email)) {
        openNotificationWithIcon(this.$t('common_home_enter_email_address_format_incorrect'))
        return false
      }
      if (!realName) return openNotificationWithIcon(this.$t('authority_account_请输入账号名'))
      if (!userId) {
        if (!pwd) return openNotificationWithIcon(this.$t('authority_account_passwords') + '!')
        if (!morepwNum) return openNotificationWithIcon(this.$t('common_home_enter_email_address_format_again') + '!')
        if (pwd !== morepwNum) return openNotificationWithIcon(this.$t('authority_account_passwords_no') + '！')
        if (menuFuncList.length === 0) return openNotificationWithIcon(this.$t('authority_account_请勾选权限分配') + '!')
        if (roleMenuList.length === 0) return openNotificationWithIcon(this.$t('authority_account_请勾选权限分配') + '!')
      }
      let data = {
        email,
        phoneCode: this.countryCode,
        password: encrypt(morepwNum || ''),
        realName,
        phone,
        subjectId: this.subjectId,
        userId,
        userName,
        // menuFuncList,
        roleMenuList
      }
      this.isLoading = true
      AddSysSubAccount(data).then((res) => {
        if (res.code === '200') {
          this.seeVisible = false
          this.isLoading = false
          this.$message.success(this.$t('authority_account_操作成功'))
          this.$emit('submit')
        } else {
          openNotificationWithIcon(res.message)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    // 区号
    _PhoneCodeInterface () {
      PhoneCodeInterface({}).then(({ data }) => { // 区号
        if (!data) return
        this.countryCodeList = JSON.parse(data.result)
      })
        .finally(() => {
          this.countryCode = this.countryCodeList[0].phonecode
        })
    },
    // 区号选择
    changeInternational (val, event) {
      this.countryCodeList.forEach((item) => {
        if (item.id === val) {
          this.countryCode = item.phonecode
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.known {
  display: inline-block;
  width: 100px;
  text-align: right;
  font-size: 14px;
  margin-right: 10px;
  i {
    color: #E02020;
  }
}
.known-13 {
  display: inline-block;
  width: 100px;
  text-align: right;
  margin-right: 10px;
  font-size: 12px;
  i {
    color: #E02020;
  }
}
.power {
  display: flex;
}
.login-input {
  width:270px;
  height:32px;
  font-size:12px;
  color: #333;
  // border:1px solid rgba(221,221,221,1);
}
.login-input::placeholder {
  color: #989898;
}
.child-act__box {
  overflow-y: auto;
  // height: 530px;
  padding-bottom: 10px;
  height: 400px;
}
.child-act_input {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
}
/deep/ .ant-select-arrow-icon {
  font-size: 12px;
}
.child-act_checkbox {
  font-size: 14px;
  // margin-left: 26px;
}
.child-act_loading {
  position: relative;
  left: 14%;
  top: 75px;
}
/deep/ .ant-tree li span.ant-tree-switcher.ant-tree-switcher_close .ant-tree-switcher-icon {
  font-size: 14px;
  color: #989898;
}
/deep/ .ant-checkbox + span {
  padding-left: 5px;
}
/deep/ .ant-input {
  font-size: 12px;
  -webkit-text-security: disc
}
/deep/ .ant-tree li span.ant-tree-switcher {
  position: relative;
  right: 3px;
}
/deep/.ant-tree li .ant-tree-node-content-wrapper {
  font-size: 14px;
}
</style>
